import type { ReactNode } from 'react';

export const symbol_align_vertical_top: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M304.5-94.58Q290-109.17 290-130v-540q0-20.83 14.62-35.42Q319.24-720 340.12-720q20.88 0 35.38 14.58Q390-690.83 390-670v540q0 20.83-14.62 35.42Q360.76-80 339.88-80 319-80 304.5-94.58Zm280-240Q570-349.17 570-370v-300q0-20.83 14.62-35.42Q599.24-720 620.12-720q20.88 0 35.38 14.58Q670-690.83 670-670v300q0 20.83-14.62 35.42Q640.76-320 619.88-320q-20.88 0-35.38-14.58ZM110-820q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-880 110-880h740q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H110Z"
		/>
	</svg>
);
